import React, { Component } from 'react';
import { Facebook, Instagram, Twitter } from '../../assets/images/index.js';
import { I18n } from 'react-i18next';
import i18n from '../../i18n';


export default class SocialContainer extends Component {
  render() {
    return (
      <I18n>
        {
          (t, { i18n }) => (
          <div className="SocialContainer">
            <div className="social-title">{t('footerFollowSocial')}</div>
            <div className="social-item-wrapper">
              <a href="https://www.instagram.com/foreverplantsgroup/" className="social-item">
                <Instagram />
              </a>
              <a
                href="https://twitter.com/FPG_NL"
                className="social-item"
                target="_blank"
                rel="noopener noreferrer">
                <Twitter />
              </a>
              <a
                href="https://www.facebook.com/foreverplantsgroup/"
                className="social-item"
                target="_blank"
                rel="noopener noreferrer">
                <Facebook />
              </a>
            </div>
          </div>
        )
      }
      </I18n>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SocialContainer/SocialContainer.jsx